// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 10px 10px 10px;
  background: #fff;
  margin: 0;
  overflow: hidden;
}

.title {
  font-family: BricolageGrotesque;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.06em;
  text-align: center;
  color: var(--color-black);
  text-transform: uppercase;
}

.info {
  font-family: BricolageGrotesque;
  font-size: 12px;
  margin: 5px 0px 10px;
  letter-spacing: 0.02em;
  text-align: center;
  color: var(--color-black);
}

.button {
  height: 50px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  border-radius: 26px;
  text-transform: uppercase;
  font-family: BricolageGrotesque;
  cursor: pointer;
}
.button:last-child {
  margin-bottom: 0;
}
.button:hover {
  background: #2D69AA;
}
.button_main {
  background: #2D69AA;
  font-size: var(--buttons-font-size);
  font-size: 14px;
  line-height: 25px;
  letter-spacing: 0.06em;
  text-align: center;
}
.button_close {
  background: transparent;
  border: 1px solid #2D69AA;
  font-size: 14px;
  min-height: 25px;
  text-align: center;
  margin: 0;
  text-transform: var(--buttons-text-transform);
  color: var(--color-black);
}`, "",{"version":3,"sources":["webpack://./src/app/components/change-venue-popover/change-venue-popover.component.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,SAAA;EAGA,gBAAA;AADJ;;AAIE;EACE,+BAAA;EACA,eAAA;EACA,iBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,yBAAA;EACA,yBAAA;AAFJ;;AAKE;EACE,+BAAA;EACA,eAAA;EACA,oBAAA;EAEA,sBAAA;EACA,kBAAA;EACA,yBAAA;AAHJ;;AAOE;EACE,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,+BAAA;EAEA,eAAA;AALJ;AAMI;EACE,gBAAA;AAJN;AAMI;EACE,mBAAA;AAJN;AAOI;EACE,mBAAA;EACA,mCAAA;EAEA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;AANN;AAUI;EACE,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EAEA,SAAA;EACA,6CAAA;EACA,yBAAA;AATN","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    padding: 10px 10px 10px;\n    background: #fff;\n    margin: 0;\n\n\n    overflow: hidden;\n  }\n  \n  .title {\n    font-family: BricolageGrotesque;\n    font-size: 16px;\n    font-weight: bold;\n\n    letter-spacing: 0.06em;\n    text-align: center;\n    color: var(--color-black);\n    text-transform: uppercase;\n  }\n  \n  .info {\n    font-family: BricolageGrotesque;\n    font-size: 12px;\n    margin: 5px 0px 10px;\n\n    letter-spacing: 0.02em;\n    text-align: center;\n    color: var(--color-black);\n\n  }\n  \n  .button {\n    height: 50px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    margin-bottom: 10px;\n    border-radius: 26px;\n    text-transform: uppercase;\n    font-family: BricolageGrotesque;\n    // max-width: 150px;\n    cursor: pointer;\n    &:last-child {\n      margin-bottom: 0;\n    }\n    &:hover {\n      background: #2D69AA;\n\n    }\n    &_main {\n      background: #2D69AA;\n      font-size: var(--buttons-font-size);\n\n      font-size: 14px;\n      line-height: 25px;\n      letter-spacing: 0.06em;\n      text-align: center;\n\n    }\n  \n    &_close {\n      background: transparent;\n      border: 1px solid #2D69AA;\n      font-size: 14px;\n      min-height: 25px;\n      text-align: center;\n  \n      margin: 0;\n      text-transform: var(--buttons-text-transform);\n      color: var(--color-black);\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
